/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * AssignmentUpdateMainComponent
 *
 * @file AssignmentUpdateMainComponent.jsx
 * @author Ujjwal Sana
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import SyllabusProvider from '../contexts/SyllabusContext';
import AssignmentListMainComponent from './AssignmentList/AssignmentListMainComponent';

const AssignmentUpdateMainComponent = (props) => {
  const { syllabusProps,
    onUploadComplete,
    renderInModal,
    handleAddAssignemntPopupClose,
    editingAssignment = null,
    editingIndex = null,
    onEditComplete,
    onDeleteComplete,
    onSaveSingleAssignment,
    currentAssignedList,
    restrictAlreadyAssigned = true,
    currentAssignmentIdx = 0,
    addAssignmentCount,
    isLoading = false } = props;

  return (
    <SyllabusProvider
      clientInformation={syllabusProps.clientInformation}
      onFileError={syllabusProps.onFileError}
      onEditClick={syllabusProps.onEditClick}
      ctaLabels={syllabusProps.ctaLabels}
      currentAssignedList={currentAssignedList}
      assignmentDefaults={syllabusProps.assignmentDefaults}
      onAssignmentDefaultsChange={syllabusProps.onAssignmentDefaultsChange}
    >
      <AssignmentListMainComponent
        parentApp={syllabusProps.parentApp}
        textInfo={syllabusProps.textInfo}
        tocData={syllabusProps.tocData}
        chapterMcqMapping={syllabusProps.chapterMcqMapping}
        onUploadComplete={onUploadComplete}
        renderInModal={renderInModal}
        handleAddAssignemntPopupClose={handleAddAssignemntPopupClose}
        editingAssignment={editingAssignment}
        editIndex={editingIndex}
        onEditComplete={onEditComplete}
        onDeleteComplete={onDeleteComplete}
        assignmentFormActions={syllabusProps.assignmentFormActions}
        showListView={false}
        onSaveAndAdd={onSaveSingleAssignment}
        restrictAlreadyAssigned={restrictAlreadyAssigned}
        currentAssignmentIdx={currentAssignmentIdx}
        addAssignmentCount={addAssignmentCount}
        showPublishButton={syllabusProps?.showPublishButton}
        currentAssignedList={currentAssignedList}
        isLoading={isLoading}
        timeZoneOptions={syllabusProps?.timeZoneOptions}
        excludeTitles={syllabusProps?.excludeTitles}
        showAssignmentTitle={syllabusProps?.showAssignmentTitle}
        titleValidationConfig={syllabusProps?.titleValidationConfig}
        assignmentConfig={syllabusProps?.assignmentConfig}
      />
    </SyllabusProvider>);
};

AssignmentUpdateMainComponent.propTypes = {
  renderInModal: PropTypes.bool,
  syllabusProps: PropTypes.object.isRequired,
  handleAddAssignemntPopupClose: PropTypes.func,
  onUploadComplete: PropTypes.func,
  editingAssignment: PropTypes.object,
  editingIndex: PropTypes.string,
  onDeleteComplete: PropTypes.func,
  onEditComplete: PropTypes.func,
  onSaveSingleAssignment: PropTypes.func,
  restrictAlreadyAssigned: PropTypes.bool,
  currentAssignedList: PropTypes.array,
  currentAssignmentIdx: PropTypes.number,
  addAssignmentCount: PropTypes.number,
  isLoading: PropTypes.bool
};

AssignmentUpdateMainComponent.defaultProps = {
  renderInModal: true,
  editingAssignment: null,
  editingIndex: null,
  handleAddAssignemntPopupClose: () => {},
  onUploadComplete: () => {},
  onDeleteComplete: () => {},
  onEditComplete: () => {},
  onSaveSingleAssignment: () => {},
  restrictAlreadyAssigned: true,
  currentAssignedList: null,
  currentAssignmentIdx: 0,
  addAssignmentCount: 0,
  isLoading: false

};

export default AssignmentUpdateMainComponent;
